
import { defineComponent } from "vue";
export default defineComponent({
  name: "modal",
  props: {
    openModal: Boolean,
    title: String,
  },
  emits: ["close"],
});
